export default __webpack_public_path__ + "static/media/phone-girl.14884c69.png";